export default "__VITE_ASSET__CFqBCQMv__"